import { type LootBoxTokenIdMapping } from '@app/store/types/artifacts';
import { type ArtifactsAction, SET_LOOT_BOX_TOKEN_ID_MAPPING } from '@app/store/types/artifacts-actions';

export function setLootBoxTokenIdMapping(lootboxTokenIdMapping: LootBoxTokenIdMapping): ArtifactsAction {
    return {
        type: SET_LOOT_BOX_TOKEN_ID_MAPPING,
        lootboxTokenIdMapping,
    };
}
